export default "/7ee56fc642439642e071ad6692a1a8b95a874bf4/ee9346a7a9322dc42520ebdf49402b79.svg";